const IMask = require('imask')

function getPhoneNumberMask (phoneNumberWithCountryCode, countryCodes) {
  let parsedPhoneNumber = (phoneNumberWithCountryCode || '')
  let mask = '### ### ####'

  if (parsedPhoneNumber && parsedPhoneNumber.indexOf('+') > -1) {
    countryCodes.forEach((item) => {
      if (parsedPhoneNumber && parsedPhoneNumber.indexOf(item.code) === 0) {
        parsedPhoneNumber = parsedPhoneNumber.replace(item.code, '')

        switch (item.code) {
          case '+1':
            // eslint-disable-next-line no-useless-escape
            mask = '\(###\) ###\-####'
            break
          case '+49':
            mask = '## #### ####'
            break
          case '+44':
          case '+31':
          case '+39':
          case '+233':
            mask = '## ### ####'
            break
        }
      }
    })
  }

  return mask
}

const usPhoneNumberMask = IMask.createPipe({
  mask: '(000) 000-0000'
})

const intlPhoneNumberMask = IMask.createPipe({
  mask: '000 000 0000'
})

const ukPhoneNumberMask = IMask.createPipe({
  mask: '00 000 0000'
})

const swissPhoneNumberMask = IMask.createPipe({
  mask: '00 000 0000'
})

const germanyPhoneNumberMask = IMask.createPipe({
  mask: '00 0000 0000'
})

const ukPhoneNumberMaskWithPrefixZero = IMask.createPipe({
  mask: '000 000 0000'
})

function maskPhoneNumber (phoneNumberWithCountryCode, countryCodes, excludePrefix) {
  let parsedPhoneNumber = (phoneNumberWithCountryCode || '')
  let maskedPhoneNumber = ''

  if (parsedPhoneNumber && parsedPhoneNumber.indexOf('+') > -1) {
    countryCodes.forEach((item) => {
      if (parsedPhoneNumber && parsedPhoneNumber.indexOf(item.code) === 0) {
        parsedPhoneNumber = parsedPhoneNumber.replace(item.code, '')

        switch (item.code) {
          case '+1':
            maskedPhoneNumber = (excludePrefix ? '' : item.code + ' ') + usPhoneNumberMask(parsedPhoneNumber)
            break
          case '+41':
            maskedPhoneNumber = (excludePrefix ? '' : item.code + ' ') + swissPhoneNumberMask(parsedPhoneNumber)
            break
          case '+49':
            maskedPhoneNumber = (excludePrefix ? '' : item.code + ' ') + germanyPhoneNumberMask(parsedPhoneNumber)
            break
          case '+44':
          case '+31':
          case '+39':
          case '+233':
            maskedPhoneNumber = (excludePrefix ? '' : item.code + ' ') +
              (parsedPhoneNumber.length > 1 && parsedPhoneNumber.length <= 10 && parsedPhoneNumber.substring(0, 1) === '0'
                ? ukPhoneNumberMaskWithPrefixZero(parsedPhoneNumber)
                : ukPhoneNumberMask(parsedPhoneNumber))
            break
          default:
            maskedPhoneNumber = (excludePrefix ? '' : item.code + ' ') + intlPhoneNumberMask(parsedPhoneNumber)
        }
      }
    })
  } else {
    maskedPhoneNumber = parsedPhoneNumber
  }

  return maskedPhoneNumber
}

function extractPhonePrefixFromNumber (phoneNumber, countryCodes) {
  let phonePrefix = ''

  for (let i = 0; i < countryCodes.length; i++) {
    const item = countryCodes[i]

    if (phoneNumber && phoneNumber.indexOf(item.code) === 0) {
      if (item.code === '+1' && phoneNumber.length === 12) {
        phonePrefix = '+1'
      } else if (item.code === '+44' && phoneNumber.length === 12) {
        phonePrefix = '+44'
      } else if (item.code === '+233' && phoneNumber.length === 13) {
        phonePrefix = '+233'
      } else {
        phonePrefix = item.code
      }

      return phonePrefix
    }
  }

  return phonePrefix
}

function getPhonePrefixByCountryId (countryId) {
  switch (countryId) {
    case 'GHA':
      return '+233'
  }
}

function stripPhoneMask (maskedPhoneNumber) {
  return (maskedPhoneNumber || '').replace(/[^+0-9]/g, '')
}

const phoneNumberCountryCodes = [
  { code: '+233', title: 'Ghana', countryId: 'GHA' },
  { code: '+1', title: 'North America (Canada, US)', countryId: 'USA' },
  { code: '+44', title: 'United Kingdom', countryId: 'GBR' },
  { code: '+31', title: 'Netherlands', countryId: 'NLD' },
  { code: '+39', title: 'Italy', countryId: 'ITA' },
  { code: '+49', title: 'Germany', countryId: 'DEU' },
  { code: '+41', title: 'Switzerland', countryId: 'CHE' }
]

/**
 * Returns an array of phone number country code objects
 * @returns {{ code:string, title:string, countryId:string }[]}
 */
function getPhoneNumberCountryCodes () {
  return [].concat(phoneNumberCountryCodes)
}

module.exports = {
  getPhoneNumberMask,
  maskPhoneNumber,
  extractPhonePrefixFromNumber,
  getPhonePrefixByCountryId,
  getPhoneNumberCountryCodes,
  stripPhoneMask
}
